import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  Button,
  Typography,
  GridList,
  fade,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
} from '@material-ui/core'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import { ReactComponent as ScheduleSelectedIcon } from 'src/mobile/assets/icons/schedule-selected.svg'
import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import { useDateFnsLocale } from 'src/hooks'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { getDoctorBookings } from 'src/store/slices/userSlice'
import { getClinicDoctorList } from 'src/store/slices/testCenterSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Loading from '../Loading'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    clinicInfo: {
      marginTop: theme.spacing(-5.25),
      marginBottom: theme.spacing(3),
    },
    bold: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    clinicName: {
      color: theme.palette.grey[600],
      marginTop: theme.spacing(0.5),
    },
    scheduleWrapper: {
      paddingBottom: theme.spacing(3),
    },
    scheduleWrapper2: {
      minHeight: 100,
      display: 'block',
      textAlign: 'center',
    },
    scheduleCell: {
      cursor: 'pointer',
      position: 'relative',
      backgroundColor: theme.palette.assistant.assistant05,
      borderRadius: theme.spacing(0.5),
      height: '100%',
      textAlign: 'center',
      padding: theme.spacing(0.5, 0),
    },
    fulled: {
      color: '#D1D5DB',
    },
    closeButton: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(2),
      color: '#111827',
      border: ' 1px solid #111827',
    },
    selectedTime: {
      color: theme.palette.secondary.main,
      backgroundColor: fade(theme.palette.secondary.main, 0.1),
      border: `1px solid ${theme.palette.secondary.main}`,
    },
    scheduleSelectedIcon: {
      position: 'absolute',
      bottom: -2,
      right: -1,
    },
    underline: {
      textDecoration: 'underline',
    },
    label: {
      position: 'relative',
      flexDirection: 'row-reverse',
      marginLeft: '15px',
    },
    radio: {
      position: 'absolute',
      top: 10,
      left: 250,
    },
  }),
)

const ScheduleDrawer = ({ clinic, onStoreOrder, price, currency, authenticated, packages }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  // const [tB] = useCustomTranslation()
  const { t } = useTranslation()
  const theme = useTheme()

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const { weekDaysArray } = useDateFnsLocale()
  const [state, setState] = useState(false)
  // const [bookings, setBookings] = useState(null)
  const [selectedTime, setSelectedTime] = useState(null)
  const [confirmed, setConfirmed] = useState(false)
  const { userInfo } = useSelector((state) => state.auth)
  // const { bookingsStatus } = useSelector((state) => state.user)
  const { clinicDoctorList, getAllTimeStatus, allTime } = useSelector((state) => state.testCenter)

  useEffect(() => {
    setState(Boolean(clinic?.week || clinic?.week === 0))
    if (!clinic) setSelectedTime(null)
  }, [clinic])
  const toggleDrawer = (e) => {
    if (e.type === 'keydown' && (e.key === 'Tab' || e.key === 'Shift')) {
      return
    }
    // removeStore('selectedDoctor')s
    setSelectedTime(null)
    setState(false)
    setTimeout(() => {
      setConfirmed(false)
    }, 300)
  }
  const handleSelect = (e) => {
    const { time, bookingCount, allBookings } = e.currentTarget.dataset
    if (bookingCount >= allBookings) return
    time && setSelectedTime(time)
  }

  const scheduleCell = (item) => {
    return (
      <Box
        key={item.value}
        mb={0.5}
        data-time={item.value}
        data-booking-count={
          allTime?.allBookings &&
          allTime?.allBookings[`${clinic?.day}`] &&
          allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
            ? allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
            : 0
        }
        data-all-bookings={allTime && item.all}
        onClick={handleSelect}
      >
        {allTime && (
          <Box
            className={classnames(classes.scheduleCell, {
              [classes.selectedTime]: selectedTime === item.value,
              [classes.fulled]:
                (allTime?.allBookings &&
                allTime?.allBookings[`${clinic?.day}`] &&
                allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
                  ? allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
                  : 0) >= item.all,
            })}
          >
            {item.value}
            {(allTime?.allBookings &&
            allTime?.allBookings[`${clinic?.day}`] &&
            allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
              ? allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
              : 0) >= item.all && <Box>{t('glossary.booking_fulled')}</Box>}
            {(allTime?.allBookings &&
            allTime?.allBookings[`${clinic?.day}`] &&
            allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
              ? allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
              : 0) < item.all &&
              getAllTimeStatus === 'fulfilled' && (
                <Box color="secondary.main">
                  <Box color={selectedTime === item.value ? 'secondary.main' : '#D1D5DB'} component="span">
                    {t('glossary.balance')}:
                  </Box>
                  {item.all -
                    (allTime?.allBookings &&
                    allTime?.allBookings[`${clinic?.day}`] &&
                    allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
                      ? allTime?.allBookings[`${clinic?.day}`][`${item.value}`]
                      : 0)}
                </Box>
              )}
            {selectedTime === item.value && <ScheduleSelectedIcon className={classes.scheduleSelectedIcon} />}
          </Box>
        )}
      </Box>
    )
  }

  const handleConfirm = () => {
    if (!clinic?.valueProgram && userInfo) {
      toast.warning(t('toast.select_toast'))
    } else if (
      (Number(clinic?.valueProgram?.package) === 4 && userInfo?.gender === '1') ||
      (Number(clinic?.valueProgram?.package) === 5 && userInfo?.gender === '0')
    ) {
      toast.warning(t('toast.gender_error'))
    } else if (!userInfo) {
      onStoreOrder?.({ selectedTime })
      setState(false)
      dispatch(
        getClinicDoctorList({
          dateFirst: selectedTime,
          week: clinic?.week,
          id: clinic?.id,
          date: clinic?.day,
          package: Number(packages),
        }),
      )
    } else {
      onStoreOrder?.({ selectedTime })
      dispatch(
        getClinicDoctorList({
          date: clinic?.day,
          dateFirst: selectedTime,
          week: clinic?.week,
          id: clinic?.id,
          package: Number(packages),
        }),
      )
      setState(false)
      setConfirmed(true)
    }
  }
  useEffect(async () => {
    if (clinicDoctorList?.length > 0) {
      let doctorId = []
      let allBookings = null
      for (let i = 0; i < clinicDoctorList?.length; i++) {
        doctorId.push(clinicDoctorList[i]?.id)
      }
      try {
        const res = await dispatch(
          getDoctorBookings({
            doctorId: doctorId,
            testCenterId: Number(clinic?.id),
          }),
        )
        allBookings = unwrapResult(res)
        console.log(allBookings)
      } catch (error) {
        console.log('Get all booking fail:', error)
      }
    }
  }, [clinicDoctorList])

  return isMobile ? (
    <EDrawer className={classes.root} open={state} onClose={toggleDrawer} title={confirmed}>
      <>
        <Box className={classes.clinicInfo}>
          <Typography className={classes.bold} variant="h4" noWrap>
            {clinic?.day} {weekDaysArray()[clinic?.week]}
          </Typography>
          <Typography className={classnames(classes.bold, classes.clinicName)} noWrap>
            {clinic?.name}
          </Typography>
          <Box mr="auto" color="secondary.main">
            <Box mt={1}>
              {t('glossary.service_charge')}:
              <Box>
                <ENumberFormat color="secondary.main" value={Number(price)} currency={currency} />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display="flex" flexDirection="column">
          <Box>
            {' '}
            <GridList
              className={
                getAllTimeStatus === 'fulfilled'
                  ? Object.keys(allTime?.allTime).length === 0
                    ? classes.scheduleWrapper2
                    : classes.scheduleWrapper
                  : classes.scheduleWrapper2
              }
              cols={
                getAllTimeStatus === 'fulfilled' ? (Object.keys(allTime?.allTime).length === 0 ? 1 : 3) : 3
              }
              cellHeight={40}
              spacing={8}
            >
              {getAllTimeStatus === 'fulfilled' ? (
                Object.keys(allTime?.allTime).length === 0 ? (
                  <Typography variant="h3" style={{ fontWeight: 600, lineHeight: 3 }}>
                    {t('common.doctor_pause_work')}
                  </Typography>
                ) : (
                  Object.entries(allTime?.allTime)
                    .sort((a, b) => {
                      return a[0].localeCompare(b[0])
                    })
                    .map(([key, value]) => ({ value: key, all: value }))
                    ?.map((item) => scheduleCell(item))
                )
              ) : (
                <Loading />
              )}
            </GridList>
          </Box>
          <FixedButtonWrapper>
            <Button
              disabled={!selectedTime}
              variant="contained"
              color="primary"
              onClick={handleConfirm}
              fullWidth
            >
              {t('common.confirm')}
            </Button>
          </FixedButtonWrapper>
        </Box>
      </>
    </EDrawer>
  ) : (
    <Dialog open={state}>
      <Box mb={2}>
        <Box py={2} fontSize={20} fontWeight={600} textAlign="center">
          {clinic?.day} {weekDaysArray()[clinic?.week]}
        </Box>
        <IconButton aria-label="close" className={classes.closeButton} onClick={toggleDrawer}>
          <CloseIcon />
        </IconButton>
        <Divider className={classes.dividerStyle} />
      </Box>
      <DialogContent>
        <DialogContentText>
          <>
            <Box className={classes.clinicInfo} pt={5} minWidth={400}>
              <Box mr="auto" color="secondary.main">
                <Box mt={1}>
                  {t('glossary.service_charge')}:
                  <Box>
                    <ENumberFormat color="secondary.main" value={Number(price)} currency={currency} />
                  </Box>
                </Box>
              </Box>
            </Box>
            <GridList
              className={
                getAllTimeStatus === 'fulfilled'
                  ? Object.keys(allTime?.allTime).length === 0
                    ? classes.scheduleWrapper2
                    : classes.scheduleWrapper
                  : classes.scheduleWrapper2
              }
              cols={
                getAllTimeStatus === 'fulfilled' ? (Object.keys(allTime?.allTime).length === 0 ? 1 : 3) : 3
              }
              cellHeight={50}
              spacing={8}
            >
              {getAllTimeStatus === 'fulfilled' ? (
                Object.keys(allTime?.allTime).length === 0 ? (
                  <Typography variant="h5" style={{ fontWeight: 600, lineHeight: 3 }}>
                    {t('common.doctor_pause_work')}
                  </Typography>
                ) : (
                  Object.entries(allTime?.allTime)
                    .sort((a, b) => {
                      return a[0].localeCompare(b[0])
                    })
                    .map(([key, value]) => ({ value: key, all: value }))
                    ?.map((item) => scheduleCell(item))
                )
              ) : (
                <Loading />
              )}
            </GridList>
          </>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} variant="contained" color="secondary" disabled={!selectedTime}>
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ScheduleDrawer
